module.exports = __webpack_public_path__ + "static/media/wk-bias.0ca142f1.svg";